import React, { useState } from 'react'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import SuggestField from '@modules/admin/common/fields/suggestField'
import Consultations from '@services/Consultations'
import InfoPanel from '@modules/admin/common/infoPanel'
import InputField from '@modules/formFields/InputField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectField from '@modules/formFields/SelectField'
import Button from '@modules/admin/common/button'
import SpecialitiesSchedulesField from '@modules/admin/groups/components/specialitiesSchedulesFiels'
import FeedSelector from '@modules/admin/groups/components/feedSelector'
import UserGroupsModal from '@modules/admin/groups/components/userGroupsModal'
import UploadJSON from '@modules/formFields/UploadJSON'
import { FEATURE_FLAGS } from '@feature-flags/feature-flags.constants'
import { FEATURES } from '@feature-flags/features.constants'
import Label from '../common/label'

const GroupsUserForm = ({
  initialValues,
  companySpecialities,
  companyServices,
  allFeeds,
  assignedFeeds,
  handleSubmit,
  onSubmit,
  submitting,
  fileName,
  jsonConf,
  t,
}) => {
  const [customerModal, setCustomerModal] = useState(false)
  const [disabledButton, setDisabledButton] = useState(submitting)
  const { customers_count } = initialValues
  const companyId = initialValues?.company?.id
  const userGroupId = initialValues?.id
  const isDefaultGroup = initialValues?.is_default
  const isProd = location.hostname.includes('admin.meetingdoctors.com')
  const url = isProd ? 'https://panel.meetingdoctors.com' : 'https://panel.staging.meetingdoctors.com'
  const themeLink = `${url}/main/groups/${userGroupId}/theme`
  const allowScheduledAppointmentsLink = `${url}/main/groups/${userGroupId}/services/bookable-services`

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <InfoPanel background="yellow" text={t('disclaimerUserGroup')} iconFont="fa-exclamation-triangle" />
      {/* bootstrap flex class gap */}
      <Field
        name="name"
        disabled={isDefaultGroup}
        component={InputField}
        placeholder={t('groupName')}
        label={t('groupName')}
      />
      <Field
        name="code"
        disabled={isDefaultGroup}
        component={InputField}
        placeholder={t('groupCode')}
        label={t('groupCode')}
      />
      {!initialValues?.id && (
        <Field
          name="company"
          component={SelectCompanyField}
          placeholder={t('associatedCompany')}
          label={t('associatedCompany')}
        />
      )}
      {customerModal && (
        <UserGroupsModal
          title={t('usersAssociatedGroup', { usersSize: customers_count })}
          className="table-associated"
          hide={() => setCustomerModal(false)}
          client={(params) => Consultations.userGroups.customersAssociates(companyId, userGroupId, params)}
          isDefaultGroup={isDefaultGroup}
          t={t}
        />
      )}
      {initialValues.id && (
        <>
          <Field
            name="customers"
            label={t('associatedUsers')}
            placeholder={t('addUsersGroups')}
            component={SuggestField}
            client={(params) => Consultations.userGroups.customersNotAssociates(companyId, userGroupId, params)}
          />
          <Button type="button" grey rightIcon={'fa-chevron-right'} onClick={() => setCustomerModal(true)}>
            {t('viewAssociatedUsers', { usersSize: customers_count })}
          </Button>
          {FEATURE_FLAGS[FEATURES.CONTENT] ? (
            <Field
              name="feeds"
              label={'Feeds'}
              placeholder={'Feeds'}
              component={FeedSelector}
              assignedFeeds={assignedFeeds}
              options={allFeeds}
              multi
            />
          ) : null}
          <Field
            multi
            name="services"
            component={SelectField}
            options={companyServices}
            label={t('activeServices')}
            placeholder={t('activeServices')}
          />

          {/*<Field*/}
          {/*  multi*/}
          {/*  name="services"*/}
          {/*  component={SelectField}*/}
          {/*  options={[*/}
          {/*    {id: 'videollamada', name: 'videollamada'},*/}
          {/*    {id: 'prescription', name: 'Receta electronica'},*/}
          {/*  ]}*/}
          {/*  label={t('activeServices')}*/}
          {/*  placeholder={t('activeServices')}*/}
          {/*/>*/}
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Label>
              {t('company-group.bookable-service.title', {
                defaultValue: 'Permitir citas agendadas',
              })}
            </Label>
            <Field name="service_booking_enabled" type="checkbox" component="input" className="check-box" />
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => window.open(allowScheduledAppointmentsLink, '_blank')}
            >
              {t('assignServices', {
                defaultValue: 'Asignar servicios agendables',
              })}
            </button>
          </span>
          <br />
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Label>
              {t('company-group.chat-attachments-button.title', {
                defaultValue: 'Permitir adjuntar archivos en el chat',
              })}
            </Label>
            <Field name="chat_attachment_enabled" type="checkbox" component="input" className="check-box" />
          </span>
          <br />

          <Field
            name="specialities"
            label={t('assignedSpecialities')}
            placeholder={t('assignedSpecialities')}
            component={SpecialitiesSchedulesField}
            options={companySpecialities}
            multi
          />
          <Field
            name="teams"
            label={t('assignedProfessionalGroups')}
            placeholder={t('assignedProfessionalGroups')}
            component={SuggestField}
            client={(params) => Consultations.teams.index(params)}
            draggable
          />
          <InfoPanel background="grey" text={t('disclaimerOrderGroup')} iconFont="fa-hand-paper" />

          <Field
            name="group_options"
            label={t('uploadJSON')}
            component={UploadJSON}
            fileName={fileName}
            disabledButton={setDisabledButton}
            jsonConf={jsonConf}
            t={t}
          />
          <br />
          <InfoPanel
            background="grey"
            text={t('company-group.theme.disclaimer')}
            iconFont="fa-palette"
            link={{
              text: t('company-group.theme.text-link'),
              url: themeLink,
            }}
          />
        </>
      )}
      <button type="submit" className="btn btn-primary" disabled={disabledButton}>
        {t('saveUserGroup')}
      </button>
    </Form>
  )
}

const validate = (values, props) => {
  let errors = {}
  const { t } = props
  if (!values.name) errors.name = t('Campo requerido')
  if (!values.company) errors.company = t('Campo requerido')
  // if (!values.services?.length) errors.services =  t('Campo requerido');
  if (!values.code) errors.code = t('Campo requerido')
  // if (!values.professionals?.length) errors.professionals = "requerido";

  return errors
}
export const UserGroupsRedux = reduxForm({
  form: 'userGroups',
  validate,
})(GroupsUserForm)
